export const BAND_UI = {
  k2: {
    label: "K–2",
    kidTitle: "Catch Your Frog!",
    pickPrompt: "Which one is your frog today?",
    doneBtn: "I CAUGHT MY FROG!",
    workingMsg: "Catch your frog first, then everything else is easy!",
    celebrate: "RIBBIT! You caught it!",
    resetMsg: "Easy day today. Frogs are slippery sometimes!",
    q1: "Was your frog tricky?",
    q2: "Did you catch it FIRST?",
  },
  "35": {
    label: "Grades 3–5",
    kidTitle: "Worst First!",
    pickPrompt: "What's the task you really don't want to do?",
    doneBtn: "FROG DONE!",
    workingMsg: "Do the worst one first. The rest is downhill.",
    celebrate: "Boom! Worst one crushed!",
    resetMsg: "Easy day. Everyone misses a frog sometimes.",
    q1: "Was it as bad as you thought?",
    q2: "Did you do it first?",
  },
  "68": {
    label: "Grades 6–8",
    kidTitle: "Frog + Time Guess",
    pickPrompt: "Pick your hardest task and guess the minutes.",
    doneBtn: "FROG EATEN",
    workingMsg: "Single-task it. No jumping around.",
    celebrate: "Eaten! Was your time guess close?",
    resetMsg: "Easy day logged. The habit matters, not perfection.",
    q1: "Harder or easier than you guessed? (Hard?)",
    q2: "Did you start with it?",
  },
  912: {
    label: "Grades 9–12",
    kidTitle: "Eat That Frog (A1)",
    pickPrompt: "What's your A1 — the hardest task with real consequences?",
    doneBtn: "A1 COMPLETE",
    workingMsg: "Your A1 comes first. Everything else waits.",
    celebrate: "A1 down. That's the whole method.",
    resetMsg: "Easy day. Reset, then plan tomorrow's A1 tonight.",
    q1: "Was it genuinely your hardest task?",
    q2: "Did you eat it first?",
  },
};

export const CHILD_COLORS = ["#22C55E", "#38BDF8", "#F472B6", "#FBBF24", "#A78BFA", "#FB923C"];
